import DetectClickOutside from './DetectClickOutside'

export default DetectClickOutside
